module.exports = __webpack_public_path__ + "img/4.e27be513.png";